// import Vue from 'vue';
import VueMaterial from 'vue-material';
import VueResource from 'vue-resource';
import VueTouch from 'vue-touch';
import moment from 'moment';
import VeeValidate, { Validator } from 'vee-validate';
import money from 'v-money';
import VueTheMask from 'vue-the-mask';
import Toast from '../common/functions/toast';
import ErrorHandler from '../common/functions/error-handler';
import Moment from '../common/functions/moment';
import Lodash from '../common/functions/lodash';
import APIResources from '../custom/especializacao/common/resources';

export default (Vue, ...params) => {
  // Adicionando plugins ao Core do Vue
  Validator.installDateTimeValidators(moment);
  params.filter(el => typeof el !== 'undefined')
    .map(le => Vue.use(le));
  Vue.use(VueMaterial);
  Vue.use(VueTouch);
  Vue.use(VeeValidate);
  Vue.use(VueResource);
  Vue.use(Toast);
  Vue.use(Moment);
  Vue.use(ErrorHandler);
  Vue.use(Lodash);
  Vue.use(APIResources);
  Vue.use(money, { precision: 2 });
  Vue.use(VueTheMask);
};



// WEBPACK FOOTER //
// ./src/config/plugins.js